<template>
  <div :class="activeClasses" v-bind="rootProps">
    <span
      v-if="computedAmount !== undefined"
      class="sb-badge__label"
      :data-testid="`${props.dataTestid || 'sb-badge'}-active-label`"
    >
      {{ computedAmount <= 99 ? computedAmount : '99+' }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { isValidNumber } from '../../utils'
import { badgeSizes, badgeVariants } from './lib'

type BadgeProps = {
  amount?: number
  size?: (typeof badgeSizes)[number]
  variant?: (typeof badgeVariants)[number]
  dataTestid?: string
  // eslint-disable-next-line vue/prop-name-casing
} & /* @vue-ignore */ HTMLAttributes

const props = withDefaults(defineProps<BadgeProps>(), {
  amount: 0,
  size: 'small',
  variant: 'unread',
})

const rootProps = reactiveOmit(props, ['size', 'amount', 'variant'])

const isRead = computed(() => props.variant === 'read')
const activeClasses = computed(() => [
  'sb-badge',
  `sb-badge--${isRead.value ? 'large' : props.size}`,
  `sb-badge--${props.variant}`,
])
const computedAmount = computed(() => {
  // When the badge variant is 'read'.
  // We should always display the amount.
  if (props.size === 'small' && !isRead.value) {
    return undefined
  }
  return isValidNumber(props.amount) ? props.amount : undefined
})
</script>
